/**
 * Utilidades para manejar rutas con slug
 */
import { getCompanySlugFromUrl, sanitizeCompanySlug } from './companyDetector';

export function sanitizeInternalPath(route) {
  if (!route || typeof route !== 'string') {
    return '/';
  }

  const trimmed = route.trim();
  if (trimmed.startsWith('//') || /https?:\/\//i.test(trimmed)) {
    return '/';
  }

  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

/**
 * Genera una ruta con slug si es necesario
 * Si el dominio es app.hospedapp.cl y hay un slug, lo incluye en la ruta
 * Si no hay slug o el dominio es diferente, retorna la ruta sin slug
 * 
 * @param {string} route - La ruta base (ej: '/home', '/calendario')
 * @returns {string} - La ruta con slug si es necesario (ej: '/santiago/home' o '/home')
 */
export function getRouteWithSlug(route) {
  // Validar que route sea una cadena válida
  if (!route || typeof route !== 'string') {
    return route || '/';
  }
  
  const hostname = window.location.hostname;
  const slug = sanitizeCompanySlug(getCompanySlugFromUrl());
  const cleanRoute = sanitizeInternalPath(route);
  
  // Si el dominio es app.hospedapp.cl y hay un slug, incluir el slug en la ruta
  if ((hostname === 'app.hospedapp.cl' || hostname.includes('app.hospedapp.cl')) && slug) {
    // Si la ruta ya tiene el slug, no duplicarlo
    if (cleanRoute.startsWith(`/${slug}/`)) {
      return cleanRoute;
    }
    return `/${slug}${cleanRoute}`;
  }
  
  // Para otros casos (subdominios o sin slug), retornar la ruta original
  return cleanRoute;
}

/**
 * Obtiene el slug actual desde la URL o localStorage
 * @returns {string|null} - El slug o null si no existe
 */
export function getCurrentSlug() {
  return getCompanySlugFromUrl();
}

/**
 * Verifica si el dominio actual requiere slug en las rutas
 * @returns {boolean} - true si se requiere slug en las rutas
 */
export function requiresSlugInRoute() {
  const hostname = window.location.hostname;
  return hostname === 'app.hospedapp.cl' || hostname.includes('app.hospedapp.cl');
}

